var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3768",
    "data-name": "Group 3768",
    transform: "translate(-1004 -792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3744",
    "data-name": "Group 3744",
    transform: "translate(1004.027 792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    transform: "translate(-0.027)",
    fill: "#fafafa",
    stroke: "#ddd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "location-1-svgrepo-com",
    d: "M14.885,24.335c-.171.125-.33.239-.476.341-.155-.1-.327-.221-.514-.355a24.022,24.022,0,0,1-3.147-2.708C8.441,19.247,6.5,16.227,6.5,13a8,8,0,0,1,16.008,0c0,3.187-2.025,6.2-4.416,8.59A28.068,28.068,0,0,1,14.885,24.335ZM24.51,13c0,8-10,14.007-10,14.007-.5,0-10-6-10-14.007a10,10,0,0,1,20.01,0Zm-8,0a2,2,0,1,1-2-2A2,2,0,0,1,16.506,13Zm2,0a4,4,0,1,1-4-4A4,4,0,0,1,18.507,13Z",
    transform: "translate(1011.495 798.994)",
    fill: "#080341",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bfa71fe06e5fa66c77bf634a6b2a3f81.svg";
export { ForwardRef as ReactComponent };